<template>
  <div
    class="retailer-search-input-fi"
    :class="{
      'retailer-search-input-fi--focused': isFocused,
      'retailer-search-input-fi--active': isActive,
      'retailer-search-input-fi--error': userLocationError,
    }"
  >
    <div class="retailer-search-input-fi__field">
      <label-fi
        class="retailer-search-input-fi__label"
        :label="$dict.get('dealer-Locator.Place-entry')"
      />
      <input
        ref="input"
        :value="value"
        class="retailer-search-input-fi__input"
        type="text"
        data-test="retailer-search-input"
        @keyup.enter="onKeyupEnter"
        @blur="onBlur"
        @focus="onFocusInput"
        @input.stop="onInput"
      />
    </div>
    <div class="retailer-search-input-fi__icons">
      <div
        class="retailer-search-input-fi__icon"
        @click.stop="searchClicked"
      >
        <icon-fi icon="search" />
      </div>
      <div
        v-if="value && value !== ''"
        class="retailer-search-input-fi__icon"
        @click="clearInput"
      >
        <icon-fi icon="close" />
      </div>
      <div
        v-else
        class="retailer-search-input-fi__icon"
        @click.stop="userLocationClicked"
      >
        <loading-indicator-wrapper
          :loading="userLocationLoading"
          variant="spinnerLocal"
          spinoff="in-relative-centered"
        >
          <icon-fi icon="my-location" />
        </loading-indicator-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
import { IconFi, LoadingIndicatorWrapper } from 'atoms';
import LabelFi from 'atoms/label-fi/LabelFi';

export default {
  name: 'RetailerSearchInputFi',
  components: {
    IconFi,
    LoadingIndicatorWrapper,
    LabelFi,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    userLocationLoading: {
      type: Boolean,
      default: false,
    },
    userLocationError: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['clear', 'input', 'keyup-enter', 'search', 'user-location'],
  data() {
    return {
      isFocused: false,
      isActive: false,
    };
  },
  watch: {
    value(newValue) {
      this.isActive = newValue !== '';
    },
  },
  methods: {
    onFocusInput() {
      this.isFocused = true;
    },
    onKeyupEnter() {
      this.$emit('keyup-enter', this.value);
    },
    clearInput() {
      this.onInput(null);
      this.$emit('clear');
    },
    searchClicked() {
      this.$emit('search', this.value);
    },
    onInput(event) {
      this.$emit('input', event ? event.target.value : null);
    },
    onBlur() {
      this.isFocused = false;
    },
    userLocationClicked() {
      this.$emit('user-location');
    },
  },
};
</script>

<style lang="postcss">
@import './retailer-search-input-fi.scss';
</style>
